export const isSandboxUrl = (url) => {
    if (URL.canParse(url)) {
        const url_object = new URL(url);
        return  url_object.hostname.includes('sandbox')
            || url_object.hostname.includes('localhost')
            || url_object.searchParams.get('sandbox') === 'true';
    }
    return false;
};
